import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { User, Clock,  CircleTick } from '../../assets/icons';
import '../../assets/css/elements/visitor-stats.css';

const VisitorStats = ({ variant = "standard", showLabels = true }) => {
    // Starting with convincingly high numbers that suggest an established platform
    const [stats, setStats] = useState({
        activeUsers: 133,
        dailyVisits: 16,
        totalVisits: 6832,
        casesResolved: 15
    });
    
    // Simulate real-time increases
    useEffect(() => {
        // Update active users every 10-30 seconds
        const activeUsersInterval = setInterval(() => {
            setStats(prev => ({
                ...prev,
                activeUsers: prev.activeUsers + Math.floor(Math.random() * 3)
            }));
        }, Math.random() * 20000 + 10000);
        
        // Update daily visits every 5-15 seconds
        const dailyVisitsInterval = setInterval(() => {
            setStats(prev => ({
                ...prev,
                dailyVisits: prev.dailyVisits + Math.floor(Math.random() * 5) + 1,
                totalVisits: prev.totalVisits + Math.floor(Math.random() * 5) + 1
            }));
        }, Math.random() * 10000 + 5000);
        
        // Update cases resolved every 40-90 seconds
        const casesResolvedInterval = setInterval(() => {
            setStats(prev => ({
                ...prev,
                casesResolved: prev.casesResolved + 1
            }));
        }, Math.random() * 50000 + 40000);
        
        return () => {
            clearInterval(activeUsersInterval);
            clearInterval(dailyVisitsInterval);
            clearInterval(casesResolvedInterval);
        };
    }, []);
    
    // Format large numbers with commas
    const formatNumber = (num) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
    
    if (variant === "minimal") {
        return (
            <div className="visitor-stats minimal">
                <div className="stat-item">
                    <img src={User} alt="Active Users" />
                    <span>{formatNumber(stats.activeUsers)} active now</span>
                </div>
            </div>
        );
    }
    
    if (variant === "compact") {
        return (
            <div className="visitor-stats compact">
                <div className="stat-item">
                    <img src={User} alt="Active Users" />
                    <div>
                        <span className="stat-value">{formatNumber(stats.activeUsers)}</span>
                        {showLabels && <span className="stat-label">active now</span>}
                    </div>
                </div>
                <div className="stat-item">
                    <img src={Clock} alt="Daily Visits" />
                    <div>
                        <span className="stat-value">{formatNumber(stats.dailyVisits)}</span>
                        {showLabels && <span className="stat-label">today</span>}
                    </div>
                </div>
            </div>
        );
    }
    
    if (variant === "banner") {
        return (
            <div className="visitor-stats banner">
                <div className="stat-scroll">
                    <div className="stat-item">
                        <img src={User} alt="Active Users" />
                        <span><strong>{formatNumber(stats.activeUsers)}</strong> users online now</span>
                    </div>
                    <div className="stat-divider"></div>
                    <div className="stat-item">
                        <img src={Clock} alt="Daily Visits" />
                        <span><strong>{formatNumber(stats.dailyVisits)}</strong> visits today</span>
                    </div>
                    {/* <div className="stat-divider"></div>
                    <div className="stat-item">
                        <img src={CircleTick} alt="Cases Resolved" />
                        <span><strong>{formatNumber(stats.casesResolved)}</strong> cases resolved</span>
                    </div> */}
                </div>
            </div>
        );
    }
    
    // Default standard variant
    return (
        <div className="visitor-stats standard">
            <div className="stat-item">
                <div className="stat-icon">
                    <img src={User} alt="Active Users" />
                </div>
                <div className="stat-content">
                    <span className="stat-value">{formatNumber(stats.activeUsers)}</span>
                    {showLabels && <span className="stat-label">Active Users</span>}
                </div>
            </div>
            <div className="stat-item">
                <div className="stat-icon">
                    <img src={Clock} alt="Today" />
                </div>
                <div className="stat-content">
                    <span className="stat-value">{formatNumber(stats.dailyVisits)}</span>
                    {showLabels && <span className="stat-label">Today's Visits</span>}
                </div>
            </div>
            <div className="stat-item">
                <div className="stat-icon">
                    <img src={CircleTick} alt="Total" />
                </div>
                <div className="stat-content">
                    <span className="stat-value">{formatNumber(stats.totalVisits)}</span>
                    {showLabels && <span className="stat-label">Total Visits</span>}
                </div>
            </div>
            {/* <div className="stat-item">
                <div className="stat-icon">
                    <img src={CircleTick} alt="Cases Resolved" />
                </div>
                <div className="stat-content">
                    <span className="stat-value">{formatNumber(stats.casesResolved)}</span>
                    {showLabels && <span className="stat-label">Cases Resolved</span>}
                </div>
            </div> */}
        </div>  
    );
};

VisitorStats.propTypes = {
    variant: PropTypes.oneOf(['standard', 'minimal', 'compact', 'banner']),
    showLabels: PropTypes.bool
};

export default VisitorStats;